import React from 'react';
import { AxiosApiService } from './axios-api-service';
import API_ENDPOINTS from '../../constants/api-endpoints';

const useAxiosApiService = (baseUrl) => React.useMemo(
    () => new AxiosApiService(baseUrl),
    [baseUrl]
);

export const useApiService = (ApiServiceClass) => {
    const axiosApiService = useAxiosApiService(API_ENDPOINTS.apiUrl);
    return React.useMemo(
        () => new ApiServiceClass(axiosApiService),
        [axiosApiService]
    );
};